module.exports = __webpack_public_path__ + "static/img/table.cfa5521.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/table.png
// module id = kcVe
// module chunks = 0